import axiosClient from "../axiosInstance";

const base = "/activities";

const getActivities = async () => {
  return axiosClient.get(base).then((response) => {
    return response.data;
  });
};

const getPlayerActivities = async (playerId) => {
  return axiosClient.get(`${base}/player/${playerId}`).then((response) => {
    return response.data;
  });
};

const getActivitiesByActionType = async (actionType) => {
  return axiosClient.get(`${base}/action/${actionType}`).then((response) => {
    return response.data;
  });
};

const getActivitiesByEntityType = async (entityType) => {
  return axiosClient.get(`${base}/entity/${entityType}`).then((response) => {
    return response.data;
  });
};

const getEntityActivities = async (entityType, entityId) => {
  return axiosClient
    .get(`${base}/${entityType}/${entityId}`)
    .then((response) => {
      return response.data;
    });
};

const getActivityById = async (activityId) => {
  return axiosClient.get(`${base}/${activityId}`).then((response) => {
    return response.data;
  });
};

const logActivity = async (activityData) => {
  return axiosClient.post(base, activityData).then((response) => {
    return response.data;
  });
};

const activityService = {
  getActivities,
  getPlayerActivities,
  getActivitiesByActionType,
  getActivitiesByEntityType,
  getEntityActivities,
  getActivityById,
  logActivity,
};

export default activityService;
